import { Reducer } from 'redux';
import { PlanningActionTypes } from './types';
import { PlanningAction } from './planning.action';
import {PbxStatus} from './config/planning.config';

import { State } from '../../@types/state';

const initialState = {
  pending: false,
  data: {
    plannings: undefined,
  },
  currentDate: new Date(),
  pxbStatus: PbxStatus.OPEN,
  errors: undefined,
};

const planning: Reducer<State['planning'], PlanningAction> = (
  state: State['planning'] = initialState,
  action: PlanningAction
) => {
  switch (action.type) {
    case PlanningActionTypes.GET_PLANNINGS_PENDING: {
      return {
        ...state,
        pending: action.pending,
        errors: undefined,
      };
    }
    case PlanningActionTypes.GET_PLANNINGS_SUCCESS: {
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    }
    case PlanningActionTypes.GET_PLANNINGS_ERROR: {
      return {
        ...state,
        pending: false,
        errors: action.message,
      };
    }
    case PlanningActionTypes.SET_CURRENT_DATE: {
      return {
        ...state,
        currentDate: action.currentDate,
      };
    }
    case PlanningActionTypes.SET_PBX_STATUS: {
      return {
        ...state,
        pxbStatus: action.status,
      };
    }
    default: {
      return state;
    }
  }
};

export default planning;
